import clsx from 'clsx'
import Image from 'next/image'

/* blocks */
import EventsNewsletterForm from '@/molecules/Forms/EventsNewsletterForm/EventsNewsletterForm'

type Props = {
  title: string
  description: string
  bgColor: string
  image?: StrapiImageFile
}

function EventsNewsletter({ title, description, bgColor, image }: Props) {
  return (
    <section
      className={clsx('text-blue-web-90 rounded-none')}
      style={{ background: bgColor }}
    >
      <div className={clsx('container | py-14')}>
        <div
          className={clsx(
            'font-heading justify-center items-center | grid grid-cols-1 lg:grid-cols-12 gap-14 md:gap-8'
          )}
        >
          <div className={clsx('md:text-left | lg:col-span-6')}>
            <h2
              className={clsx(
                'text-3xl font-semibold lg:text-4xl | tracking-tight | mb-4'
              )}
              dangerouslySetInnerHTML={{ __html: title }}
            />
            {description ? (
              <div
                className="text-lg | pb-7 md:pb-9"
                dangerouslySetInnerHTML={{ __html: description }}
              ></div>
            ) : null}
            <EventsNewsletterForm />
          </div>

          <div className="lg:col-start-8 lg:col-end-13 mx-auto relative">
            {image?.url ? (
              <Image
                src={image.url ?? ''}
                alt={image.alternativeText ?? ''}
                width={image.width}
                height={image.height}
                className="mx-auto"
              />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  )
}

export default EventsNewsletter
